import {Component, OnInit} from '@angular/core';
import {FormGroup, Validators, FormBuilder} from '@angular/forms';
import {GlobalValidator} from '../../global-validator';
import {ServerService, Server} from '../../server.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {NotificationService} from '../../notification.service';

@Component({
  selector: 'app-server-edit',
  templateUrl: './server-edit.component.html',
  styleUrls: ['./server-edit.component.css']
})
export class ServerEditComponent implements OnInit {

  public formGroup: FormGroup;

  disableSubmit = false;

  loading = false;

  editing = false;

  idExists = false;

  lastId = '';

  formErrors = {};

  actualServer = new Server('', '', 'http', '', 8020);

  validationMessages = {
    'id': {
      'required': 'Id não informada',
      'incorrectIdFormat': 'Id inválida'
    },
    'name': {
      'required': 'Nome não informado'
    },
    'hostname': {
      'required': 'Hostname não informado'
    },
    'port': {
      'required': 'Porta não informada',
      'nonInteger': 'A porta precisa ser um valor inteiro',
      'minValue': 'A porta precisa ser maior que zero',
      'maxValue': 'A porta precisa ser menor que 65535'
    }
  };

  constructor(private fb: FormBuilder, private ss: ServerService, public router: Router, public route: ActivatedRoute,
              public ns: NotificationService) {
  }

  buildForm() {
    this.formGroup = this.fb.group({
      'id': ['', [Validators.required, GlobalValidator.validIdValidator]],
      'name': ['', Validators.required],
      'hostname': ['', Validators.required],
      'port': ['8020', [Validators.required, GlobalValidator.intValueValidator,
        GlobalValidator.minValueValidator(0), GlobalValidator.maxValueValidator(65535)]]
    });
  }

  verifyExists(id: string) {
    if (id) {
      console.log(`Checking of the id ${id} exists...`);
      this.ss.verifyExists(id).subscribe((exists) => this.idExists = exists);
    } else {
      this.idExists = false;
    }
  }

  trySaveServer(model, isValid: boolean) {
    if (!isValid) {
      return;
    }
    // const server = new Server(model.id, model.name, 'http', model.hostname, +model.port);
    this.actualServer.id = model.id;
    this.actualServer.name = model.name;
    this.actualServer.hostname = model.hostname;
    this.actualServer.port = +model.port;
    this.loading = true;
    this.disableSubmit = true;
    this.ss.save(this.actualServer).subscribe((s) => {
        console.log(`Server saved successfully: ${JSON.stringify(s)}`);
        this.loading = false;
        this.disableSubmit = false;
        this.formGroup.reset();
        this.buildForm();
        this.ns.success(this.actualServer.id, 'Salvo com sucesso');
        if (this.editing) {
          this.router.navigateByUrl('/servers');
        }
      },
      (error: any) => {
        console.log(`Error saving server!! ${JSON.stringify(error)}`);
        this.ns.error(error.toString(), 'Erro ao salvar');
        this.loading = false;
      });
    return;
  }

  ngOnInit() {
    this.buildForm();
    // console.log(`${JSON.stringify(this.route.params)}`);
    this.route.params.switchMap((params: Params) => {
      const id = params['id'];
      if (id && id !== '') {
        this.editing = true;
        return this.ss.findById(id);
      } else {
        this.editing = false;
        return Observable.from([new Server('', '', 'http', '', 8020)]);
      }
    }).subscribe((s: Server) => {
      this.actualServer = s;
      this.formGroup.controls['id'].patchValue(s.id);
      this.formGroup.controls['name'].patchValue(s.name);
      this.formGroup.controls['hostname'].patchValue(s.hostname);
      this.formGroup.controls['port'].patchValue(s.port);
    });
    this.formGroup.valueChanges.debounceTime(500).subscribe((data) => this.onValueChanges(data));
  }

  onValueChanges(data?: any) {
    const form = this.formGroup;

    this.formErrors = {};

    for (const field in this.validationMessages) {
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          console.log(`got key ${key}`);
          if (!this.formErrors[field]) {
            this.formErrors[field] = '';
          }
          this.formErrors[field] += messages[key] + '. ';
        }
      }
    }

    console.log(`id value: ${form.get('id').value}`);
    if (this.lastId !== form.get('id').value) {
      this.lastId = form.get('id').value;
      this.ss.verifyExists(form.get('id').value).subscribe((result) => {
        if (result && !this.editing) {
          if (!this.formErrors['id']) {
            this.formErrors['id'] = '';
          }
          this.formErrors['id'] += 'Id já utilizada';
        }
      });
    }

    for (const error in this.formErrors) {
      if (error !== '""') {
        console.log(`Error:${JSON.stringify(this.formErrors[error])}`);
      }
    }
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/server/server-edit/server-edit.component.ts